import { Card, Text, useMantineTheme, Button } from "@mantine/core";
import { Link } from "react-router-dom";
import { useState } from "react";
import ReactCardFlip from "react-card-flip";
import PropTypes from "prop-types";
import { Pencil1Icon } from "@modulz/radix-icons";
import EditModal from "./EditTaskModal";
const type = localStorage.getItem("type");
import moment from "moment";
import { useMediaQuery } from "@mantine/hooks";
// const type = "ADMIN";

function CardExample({ task }) {
  const [isFlipped, setFlip] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const theme = useMantineTheme();
  const isScreenLarge = useMediaQuery("(min-width: 500px)", false);
  return (
    <>
      <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
        <Card
          shadow="sm"
          p="xl"
          style={{
            margin: "10px 5px",
            height: "200px",
            width: "260px",
            background: "linear-gradient(90deg, #0048B4, #0063F8,#3391FF)",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
          onMouseEnter={() => {
            setFlip(!isFlipped);
          }}
        >
          <Text
            style={{
              marginBottom: "10px",
              fontSize: "25px",
              color: "#fff",
              weight: "bold",
            }}
          >
            Task {task.taskNo}
          </Text>

          <img
            src="/Spider-Logo.svg"
            // style={{ height: "100px", width: "100px" }}
            alt="Spider R&amp;D"
          />
        </Card>

        <Card
          shadow="sm"
          p="xl"
          style={{
            height: "200px",
            background: theme.fn.linearGradient(
              125,
              "#0063F8",
              "#3391FF",
              "#00FFF0"
            ),
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent:"center",
            flexDirection: "column",
            position: "relative",
          }}
          onMouseLeave={() => {
            setFlip(!isFlipped);
          }}
        >
          {type == "ADMIN" && (
            <Pencil1Icon
              onClick={() => {
                setOpen(true);
              }}
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                color: "#fff",
                border: "1px solid #fff",
                cursor: "pointer",
                borderRadius: "2px",
                height: "20px",
                width: "20px",
              }}
            ></Pencil1Icon>
          )}

          <Text weight={500} size="xl" style={{ flex: 1, fontSize: "30px",display:isScreenLarge==false?"none":"block" }}>
            {task.title} 
          </Text>

          <Text size="md" style={{ flex: 1,display:isScreenLarge==false?"none":"block" }}>
            <span style={{ fontSize: "20px", fontWeight: "500" }}>
              {" "}
              Deadline{" "}
            </span>
            {moment(new Date(task.deadline)).format("MMMM  Do  YYYY")}
          </Text>
          <Button
            style={{ flex: 1, backgroundColor: "white", color: "blue",maxHeight:"25px" }}
            component={Link}
            to={`/dashboard/tasks/${task.id}`}
          >
            Know More
          </Button>
        </Card>
      </ReactCardFlip>
      <EditModal open={isOpen} setOpen={setOpen} task={task}></EditModal>
    </>
  );
}

CardExample.propTypes = {
  task: PropTypes.object,
};
export default CardExample;
